<template>
  <v-menu
    offset-y
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <div>
        <lx-btn
          classes="text-none rounded-r-0"
          :color="color"
          :disabled="disabled || !hasDefaultAction"
          :height="height"
          :icon="icon"
          :icon-color="iconColor"
          :icon-size="iconSize"
          :label="getDefaultActionCaption"
          :loading="loading > 0"
          :hide-label="hideLabel"
          :small="small"
          :tooltip="tooltip"
          width="auto"
          @click.self="clickDefault"/>
        <lx-btn
          classes="text-none rounded-l-0"
          :color="color"
          :disabled="disabled || !Array.isArray(items) || items.length === 0"
          :height="height"
          hide-label
          icon="mdi-dots-vertical"
          :icon-color="iconColor"
          :icon-size="iconSize"
          :small="small"
          :tooltip="tooltip"
          v-bind="attrs"
          v-on="on"
          width="auto"/>
      </div>
    </template>
    <v-list
      :color="color"
      :dark="isDarkMode"
      :dense="denseFields">
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :disabled="item.disabled === true"
        @click="clickSelect(item, index, $event)">

        <v-list-item-icon v-if="!hideListIcons">
          <v-icon
            small
            v-text="item.icon"/>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            style="cursor: pointer;font-size: 14px;"
            :style="{ color: index=== defaultActionIndex ? compColor.primeColor : '#607d8b'}"
            v-text="item.caption"/>
        </v-list-item-content>

      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LxDropdownButton',
  props: {
    color: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: 40
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideListIcons: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    iconSize: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => ([])
    },
    small: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: 0,
      defaultActionIndex: -1
    }
  },
  computed: {
    /**
     * Disable or enable reload-button in dependency to existing selection
     *
     * @returns {boolean}
     */
    hasDefaultAction () {
      return this.defaultActionIndex !== -1 || this.items.find((e) => e.default === true) !== undefined
    },

    /**
     * Set label of button in dependency to selected element from list
     *
     * @returns {string|*}
     */
    getDefaultActionCaption () {
      if (!Array.isArray(this.items)) {
        return ''
      }

      let item = undefined

      if (this.defaultActionIndex !== -1) {
        item = this.items[this.defaultActionIndex]
      } else {
        item = this.items.find((e) => e.default === true)
      }

      if (item && item.caption) {
        return item.caption
      }

      return ''
    }
  },
  async mounted () {
    this.defaultActionIndex = this.items.findIndex((e) => e.default === true)
  },
  methods: {
    /**
     * Trigger reload after selection and set defaultActionIndex
     *
     * @param item The selected element from list
     * @param index The index of selected element
     * @param event
     */
    clickSelect (item, index, event) {
      if (!item || isNaN(index)) {
        return
      }

      this.defaultActionIndex = index
      this.clickDefault(event)
    },

    /**
     * Trigger reload after clicking reload element of button or after clickSelect()
     *
     * @param event
     */
    clickDefault (event) {
      if (this.defaultActionIndex === -1) {
        this.defaultActionIndex = this.items.findIndex((e) => e.default === true)
      }

      const item = this.items[this.defaultActionIndex] || {}

      if (item && event) {
        this.$emit('click', event, item.value)
      }
    }
  }
}
</script>
